import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { PartnerUserDataGroup, Partner } from '../../models';
import { NgForm } from '@angular/forms';
import { PartnerUserService } from '../../partner-user.service';
import { fas } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-inactivate-partner-user',
  templateUrl: './inactivate-partner-user.component.html',
  styleUrls: ['./inactivate-partner-user.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class InactivatePartnerUserComponent implements OnInit {
  @Input() displayInactivateInput: boolean;
  @Input() partnerDetails: PartnerUserDataGroup;
  @Input() relationshipData: Partner;

  @Output() onDialogOpen = new EventEmitter<boolean>();
  @Output() onDialogClose = new EventEmitter<boolean>();
  @Output() onUpdatePartnerUser = new EventEmitter<any>();
  @Output() onError = new EventEmitter<string>();

  isPrimaryContactSelected = false;
  processing = false;

  constructor(private partnerUserSvc: PartnerUserService ) { }

  ngOnInit() {
    this.partnerDetails.PartnerUser.NewPrimaryContactId = null;
  }

  dialogClose() {
    console.log('onlcose');
    this.onDialogClose.emit(false);
  }

  dialogOpen() {
    this.onDialogOpen.emit(true);
  }

  onSubmit(EditPartnerUserForm: NgForm): void {
    console.log(EditPartnerUserForm.valid);
    debugger;
    if (EditPartnerUserForm.valid) {
      this.processing = true;
      this.partnerDetails.PartnerUser.Person.IsActive = false;
      this.partnerUserSvc.update(this.relationshipData.RelationshipXrefId, this.partnerDetails)
        .subscribe((personData) => {
            this.onUpdatePartnerUser.emit(personData);
            this.processing = false;
            this.dialogClose();
          }, error => {
            this.onError.emit('Error Occcured while Processing');
            this.processing = false;
            this.dialogClose();
          });
    }
  }

  /* New primary contact with RelationshipID */
  mapRelationshipAndContactId(relationshipAndContactId: any[]): void {
    this.partnerDetails.PartnerUser.NewPrimaryContactId = relationshipAndContactId[0].NewPrimaryContactId;
  }

  /* New Primary contact dropdown is valid or not */
  checkIsPrimaryContactReady(isPrimaryContactReady: boolean): void {
    this.isPrimaryContactSelected = typeof isPrimaryContactReady === 'undefined' ? true : isPrimaryContactReady;
  }
}
